<div class="app-wrapper" [attr.isAuthPage]="isAuthPage" [attr.inert]="(appBlocker.active$ | async) ? '' : null">
  <router-outlet></router-outlet>
  <div class="versions-wrapper">
    @if (isAuthPage && !isWelcomePage) {
<p class="version-text">{{showBothVersions ? 'UI - ' + 'V' + version : 'V' + version}}</p>
}
    @if (isAuthPage && !isWelcomePage && showBothVersions) {
<p class="version-text">{{'API - ' + 'V' + versionFromBack}}</p>
}
  </div>
</div>
<app-notification></app-notification>
@if (fileUploadService.inProgress$ | async) {
<div class="file-upload-blocker" id="fileUploadBlocker"></div>
}
@if (appBlocker.message$ | async; as blockerMessage) {
<div class="app-blocker" role="alert" aria-live="assertive" aria-busy="true">
  <div class="app-blocker__box">
    <span class="app-blocker__spinner"></span>
    <p class="app-blocker__message">{{ blockerMessage }}</p>
  </div>
</div>
}
